export const ES_LOCALE = 'es'
export const MX_LOCALE = 'mx'
export const EN_LOCALE = 'en'
export const PT_LOCALE = 'pt'
export const SUPPORTED_LOCALES = [ES_LOCALE, MX_LOCALE, EN_LOCALE, PT_LOCALE]


// WEBPACK FOOTER //
// ./src/constants/locales.js